import ChipComponent from './ChipComponent';

export default ChipComponent;
